import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../store';
import { DateRangePreset, IDateRange } from '../analytics.types';
import {
  computeDateRangeFromPreset,
  getDateRangeLabel,
  getDefaultAnalyticsDateRange,
} from '../analyticsUtils';

interface IAnalyticsFilterState {
  dateRange: IDateRange;
}

const initialState: IAnalyticsFilterState = {
  dateRange: getDefaultAnalyticsDateRange(),
};

const analyticsFilterSlice = createSlice({
  name: 'analyticsFilter',
  initialState,
  reducers: {
    setAnalyticsPreset(state, action: PayloadAction<DateRangePreset>) {
      const selectedPreset = action.payload;

      if (selectedPreset === 'custom') {
        state.dateRange = {
          preset: 'custom',
          startDate: '',
          endDate: '',
          label: 'Custom Range',
        };
        return;
      }

      const { startDate, endDate } = computeDateRangeFromPreset(selectedPreset);

      state.dateRange = {
        preset: selectedPreset,
        startDate,
        endDate,
        label: getDateRangeLabel(selectedPreset),
      };
    },

    setAnalyticsCustomDateRange(
      state,
      action: PayloadAction<{ startDate: string; endDate: string }>
    ) {
      const { startDate, endDate } = action.payload;

      state.dateRange = {
        preset: 'custom',
        startDate,
        endDate,
        label: 'Custom Range',
      };
    },
  },
});

export const { setAnalyticsPreset, setAnalyticsCustomDateRange } =
  analyticsFilterSlice.actions;

export const selector = (state: RootState) => state.analyticsFilter;

export default analyticsFilterSlice.reducer;